import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

export default function BusinessChart() {
  // Dummy monthly data
  const data = [
    { name: "Jan", Rides: 29000000, Events: 18000000 },
    { name: "Feb", Rides: 9000000, Events: 22000000 },
    { name: "Mar", Rides: 21000000, Events: 17000000 },
    { name: "Apr", Rides: 28000000, Events: 3000000 },
    { name: "May", Rides: 14000000, Events: 32000000 },
    { name: "Jun", Rides: 24000000, Events: 29000000 },
    { name: "Jul", Rides: 17000000, Events: 27000000 },
    { name: "Aug", Rides: 23000000, Events: 16000000 },
    { name: "Sep", Rides: 15000000, Events: 24000000 },
    { name: "Oct", Rides: 10000000, Events: 21000000 },
    { name: "Nov", Rides: 12000000, Events: 31000000 },
    { name: "Dec", Rides: 30000000, Events: 9000000 },
  ];

  const formatYAxis = (value) => `${(value / 1000000).toFixed(0)}M`;




  return (
    <div className="w-100 p-4 ">
      <div className="w-100 rounded-2 p-3" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8,backgroundColor: "#F7F9FB" }}>
        <div className="w-100 d-flex justify-content-between align-items-center mb-3">
          <div>
            <h6 className="fw-bold fs-2">Event & Rides Overview</h6>
          </div>
        </div>

        <ResponsiveContainer width="100%" height={300}>
          <BarChart
            data={data}
            margin={{ top: 5, right: 20, left: 0, bottom: 5 }}
            barGap={6}
            barCategoryGap="20%"
          >
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5e7eb" />
            <XAxis dataKey="name" tick={{ fontSize: 12 }} />
            <YAxis tickFormatter={formatYAxis} tick={{ fontSize: 12 }} />
            <Tooltip
              formatter={(value) => `${(value / 1000000).toFixed(0)}M`}
              cursor={{ fill: "rgba(0,0,0,0.04)" }}
            />
            <Legend
              verticalAlign="top"
              horizAdvX="right"
              iconType="circle"
              iconSize={10}
              wrapperStyle={{ fontSize: "0.85rem", marginTop: "-10px" }}
            />

            {/* Bars */}
            <Bar
              dataKey="Rides"
              fill="#3B33F5"
              radius={[4, 4, 0, 0]}
              maxBarSize={35}
            />
            <Bar
              dataKey="Events"
              fill="#C7A2F8"
              radius={[4, 4, 0, 0]}
              maxBarSize={35}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>

  );
}
